import { Component, OnInit } from '@angular/core';

import { LayoutService } from '../../shared/services/layout.service';

@Component({
    selector: 'login-reset-password-confirmation',
    templateUrl: 'reset-password-confirmation.component.html'
})

export class LoginResetPassConfirmationComponent{
    
    constructor(
        private _layoutService: LayoutService
    ) {
        
    }

    ngOnInit() {
        this._layoutService.setCurrentPage('login-reset-password-confirmation');
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/login/components/reset-password-confirmation.component.ts